<template>
    <div class="thank__page">
        <div class="container d-flex align-items-center justify-content-center">
            <div class="thank__body">
                <div class="text-center img">
                    <img src="/img/icon/Peace.svg" alt="">
                </div>
                <div class="title text-center">
                    <p class="Raleway p-black max-max mb-0"><b>Thank you</b></p>
                </div>
                <div class="content text-center">
                    <p class="min">Your review has been accepted and will be published soon.</p>
                </div>
                <div class="submit__btn">
                    <div class="row justify-content-center">
                        <div class="col-md-6">
                            <button class="btn btn-green btn-full small">nice!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        name: "ThankYou",
    }
</script>